const quasarKey = "_q_";
const formKey = "_q_fo_";
const uploaderKey = "_q_u_";
function emptyRenderFn() {
}
export {
  emptyRenderFn,
  formKey,
  quasarKey,
  uploaderKey
};
//# sourceMappingURL=symbols.es.js.map
